module.exports = __webpack_public_path__ + "img/tz.0c29c5bc.png";